/**
 * @fileoverview Recently Viewed Products Utility
 * @description Tracks and manages recently viewed products using localStorage
 */

const STORAGE_KEY = "pl-recently-viewed-products"
const MAX_PRODUCTS = 10

/**
 * RecentlyViewed - Utility class for managing recently viewed products
 */
export class RecentlyViewed {
  /**
   * Gets the list of recently viewed product IDs
   * @returns {string[]} Array of product IDs
   */
  static getProducts() {
    if (typeof window === "undefined" || !window.localStorage) {
      return []
    }

    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (!stored) return []

      const products = JSON.parse(stored)
      return Array.isArray(products) ? products : []
    } catch (error) {
      console.error("Failed to get recently viewed products:", error)
      return []
    }
  }

  /**
   * Adds a product to the recently viewed list
   * @param {string} productId - The product ID to add
   */
  static addProduct(productId) {
    if (typeof window === "undefined" || !window.localStorage || !productId) {
      return
    }

    try {
      const products = this.getProducts()

      // Remove if already exists (to move to front)
      const filtered = products.filter((id) => id !== productId)

      // Add to beginning
      const updated = [productId, ...filtered].slice(0, MAX_PRODUCTS)

      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated))
    } catch (error) {
      console.error("Failed to add recently viewed product:", error)
    }
  }

  /**
   * Clears all recently viewed products
   */
  static clearProducts() {
    if (typeof window === "undefined" || !window.localStorage) {
      return
    }

    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (error) {
      console.error("Failed to clear recently viewed products:", error)
    }
  }

  /**
   * Gets the count of recently viewed products
   * @returns {number} Number of recently viewed products
   */
  static getCount() {
    return this.getProducts().length
  }
}
